<template>
  <div class="router-wrapper">
    <div class="element-wrapper">
      <div class="os-tabs-w">
        <div class="os-tabs-controls os-tabs-complex">
          <div class="nav-item">
            <h1>{{ $t("reports_view.heading") }}</h1>
          </div>
        </div>
      </div>

      <div class="content-box">
        <div>
          <div class="element-box">
            <h6 class="element-header">{{ $t("general.search_criteria") }}</h6>

            <div class="row">
              <div class="col-6">
                <div class="form-group">
                  <label>{{ $t("report.charge") }}</label>
                  <input
                    name="charge"
                    v-bind:placeholder="$t('report.charge')"
                    class="form-control"
                    type="text"
                    v-model="charge"
                    v-validate="'required'"
                    :class="{ 'is-invalid': errors.has('charge') }"
                  />
                </div>
              </div>

              <div class="col-6">
                <div class="form-group">
                  <label>{{ $t("report.article_no") }}</label>
                  <input
                    name="article_number"
                    v-bind:placeholder="$t('report.article_no')"
                    class="form-control"
                    type="text"
                    v-model="articleNumber"
                    v-validate="{ required: true }"
                    :class="{ 'is-invalid': errors.has('article_number') }"
                  />
                </div>
              </div>
            </div>

            <div
              class="row"
              v-if="
                errors.has('article_number') ||
                  errors.has('charge') ||
                  `${charge}`.trim().length === 0 ||
                  `${articleNumber}`.trim().length === 0
              "
            >
              <div class="col-12" style="color: #e65252; margin-bottom: 1rem">
                {{ $t("reports_view.enter_charge_and_article_no") }}
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12 button-box" starting-position="flex-end">
                <button type="button" class="button" size="medium" @click="onClear">
                  {{ $t("general.clear") }}
                </button>
                <button type="button" class="button" color="primary" size="medium" v-on:click="onSearch">
                  {{ $t("general.search") }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="didSearch || isSearching">
          <reports-search-list
            :reports="reports"
            :USER_ROLE="this.USER_ROLE"
            :didSearch="didSearch"
            :isSearching="isSearching"
            :usage="'view'"
            :showExternalReport="showExternalReport"
            :printPdfDownloadKey="printPdfDownloadKey"
            @t="$t"
          ></reports-search-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ReportsSearchList from "@/components/react/components/reports-search-list";
import { ReactInVue } from "vuera";
import { NewReportStore } from "@/store/NewReportStore";
import { CharacteristicLanguage, PdfLayout } from "@/models/graphql-global-types";
import * as blobUtil from "blob-util";
import fileDownload from "js-file-download";
import { graphqlClient } from "@/utils/graphql";
import { PrintReport, PrintReportVariables } from "@/models/queries/types/PrintReport";
import { REPORT_PRINT_PDF_QUERY } from "@/models/queries/ReportPrintPDFQuery";

export default {
  name: "ReportView",
  data() {
    return {
      charge: null,
      articleNumber: null,
      reports: [],
      didSearch: false,
      isSearching: false,
      USER_ROLE: "",
      printPdfDownloadKey: null
    };
  },
  components: {
    "reports-search-list": ReactInVue(ReportsSearchList)
  },
  mounted() {
    this.USER_ROLE = JSON.parse(sessionStorage.getItem("cedoon_user")).role;
  },
  methods: {
    ...mapActions("reportStore", ["fetchReportView"]),
    ...mapActions("newReportStore", ["printPdfReport"]),

    onSearch() {
      this.$validator.validateAll().then(success => {
        if (success && `${this.charge}`.trim().length > 0 && `${this.articleNumber}`.trim().length > 0) {
          this.fetchReportView({
            charge: this.charge,
            articleNumber: this.articleNumber
          })
            .then(response => {
              this.reports = response.data.viewReport;
              this.didSearch = true;
              this.isSearching = false;
            })
            .catch(e => {
              this.isSearching = false;
            });
        }
      });
    },
    onClear() {
      this.charge = null;
      this.articleNumber = null;
      this.isSearching = false;
      this.reports = [];
      this.didSearch = false;
    },
    showExternalReport(reportId, sheetIds, reportSecret) {
      this.printPdfDownloadKey = `${reportSecret}-${sheetIds.join(",")}`;
      graphqlClient
        .mutate({
          mutation: REPORT_PRINT_PDF_QUERY,
          variables: {
            reportSecret: reportSecret,
            language: CharacteristicLanguage.en,
            layout: PdfLayout.STANDARD,
            sheetIds: sheetIds,
            settings: {
              pdfAttachments: false,
              imageAttachments: false,
              characteristicAttachments: false,
              technicalDrawing: false,
              materialCertificate: false
            }
          }
        })
        .then(result => {
          this.printPdfDownloadKey = null;
          let pdfWindow = window.open(this.fileName);
          pdfWindow?.document.write(
            `<iframe width='100%' height='100%' title='${this.fileName}' src='data:application/pdf;base64,
                  ${result.data.printReport.base64}
                  ' style="  position: fixed;
                    top: 0;
                    left: 0;
                    bottom: 0;
                    right: 0;
                    width: 100%;
                    height: 100%;
                    border: none;
                    margin: 0;
                    padding: 0;
                    overflow: hidden;
                    z-index: 999999;"></iframe>`
          );
        });
    }
  }
};
</script>

<style scoped lang="scss">
@import "./src/assets/theme/_variables.scss";
</style>
